import { useSelector } from "react-redux";
import useStyles from "./style";
import { Box, Button, Flex, Loader, Switch, Text } from "@mantine/core";
import moment from "moment";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { updateCardActive, updateSubscriptionCustomer } from "../../services/subscription";
import swal from "sweetalert";
import { getProfile } from "../../services/profile";

const SettingPaymentMethodCard = ({
  connected,
  loadingAccounts,
  getAllConnected,
}) => {

  const { classes } = useStyles();
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const [loading, setLoading] = useState(null);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (connected?.length > 0) {
      const activeCard = connected.find((item) => item.isActive);
      if (activeCard) {
        const index = connected.indexOf(activeCard);
        setSelectedCardId(activeCard.id || index);
      }
    }
  }, [connected]);



  const handleToggleCard = async (data, id) => {
    let startDate = moment();
    let endDate = moment(profile?.subscription?.expiredAt);
    let daysRemaining = endDate.diff(startDate, "days");
    const isTrial = Number(profile?.subscription?.packageId?.cost) === 0;
    // let text =
    //   Number(daysRemaining) > 0
    //     ? `You have ${daysRemaining} days remaining, Clicking confirm would cancel your current subscription and renew.\nPlease note, downgrading a subscription will kick in the following subscription period.`
    //     : `Clicking confirm would cancel your current subscription and renew.\nPlease note, downgrading a subscription will kick in the following subscription period.`;
    // const trialText = `Do you want to Upgrade? Please select Plan from the "Upgrade Plan" tab.`;

    let buttons = ["Cancel"];
    if (!isTrial) buttons?.push("Switch Card");

    swal({
      title: `Switch Card for "${profile?.subscription?.packageId?.name}" Plan`,
      text:  `Do you want to Switch Card?`,
      icon: "warning",
      dangerMode: isTrial ? false : true,
      buttons: buttons,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        if (!isTrial) {
          setLoading(id);
          let obj = {
            stripeSubscriptionId: profile.subscription?.stripeSubscriptionId,
            customer: data?.stripeCustomerId,
            default_source: data?.default_source
          };
          let response = await updateCardActive(obj);
          if (response.status === 200) {
            await getAllConnected();
            await getProfile()
            setLoading(null);
          } else {
            setLoading(null);
          }
        }
      }
    });
  };

  const addNewAccount = async (card, mode) => {
    navigate("/add-payment", {
      state: { card, mode }
    });
  };

  return (
    <Box className={classes.activeSubCard}>
      <p className={classes.cardHdng}>Payment Method</p>
      <Flex className={classes.infoWrapper}>
        {connected?.length === 0 && !loadingAccounts && (
          <Text className={classes.noAccountText}>No Accounts Found</Text>
        )}
        {loadingAccounts ? (
          <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
          <Loader color="yellow" size={"md"} />
          </div>
        ) : (
          connected?.map((data, index) => {
            const {
              creditCard,
              cardName,
              cardNumber,
              accountNumber,
              routingNumber,
              isActive,
            } = data;
            return (
              <Box
                key={data.id || index}
                className={classes.cardItem}
                onClick={() => setSelectedCardId(data.id || index)}
                sx={(theme) => ({
                  border:
                    selectedCardId === (data.id || index)
                      ? `3px solid ${theme.colors.blue[8]}`
                      : "1px solid #E5E5E5",
                  cursor: "pointer",
                })}
              >
                <Flex className={classes.cardItemContent}>
                  <Box style={{ flex: 1 }}>
                    <Flex className={classes.labelValueWrapper}>
                      <p className={classes.label}>
                        {creditCard ? "Card Number:" : "Routing Number:"}
                      </p>
                      <p className={classes.value}>
                        {creditCard ? cardNumber || "" : routingNumber || ""}
                      </p>
                    </Flex>
                    <Flex className={classes.labelValueWrapper}>
                      <p className={classes.label}>
                        {creditCard ? "Card Holder Name:" : "Account Number:"}
                      </p>
                      <p className={classes.value}>
                        {creditCard ? cardName || "" : accountNumber || ""}
                      </p>
                    </Flex>
                  </Box>
                  <Flex className={classes.switchWrapper}>
                    <Text className={classes.switchLabel}>
                      {isActive ? "Active" : "Inactive"}
                    </Text>
                    {loading === (data.id || index) ? (
                      <Loader size="sm" color="yellow" />
                    ) : (
                      <Switch
                        checked={isActive}
                        disabled={isActive || loading !== null}
                        onChange={() => handleToggleCard(data, data.id || index)}
                        className={classes.switch}
                      />
                    )}
                  </Flex>
                </Flex>
              </Box>
            );
          })
        )}
      </Flex>
      <Flex className={classes.btnWrapper}>
        {!loadingAccounts && selectedCardId && (
          <Button
            onClick={() => {
              const card = connected?.find(
                (c, idx) => (c.id || idx) === selectedCardId
              );
              if (card) addNewAccount(card, "update");
            }}
            className={classes.updateBtn}
          >
            Update card
          </Button>
        )}
        <Button
          onClick={() => addNewAccount(false, "create-new")}
          className={classes.addBtn}
        >
          Add New Card
        </Button>
      </Flex>
    </Box>
  );
};

export default SettingPaymentMethodCard;
